/**
 * The default/global AgGrid column settings.
 *
 * @type {Object}
 */
export default {
    autoHeight: true,
    cellClass: 'ag-grid-cell-valign-middle',

    cellStyle: {
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        overflow: 'hidden',
    },

    cellRendererParams: {
        extraParams: {
            contextMenuFilter: true,
        },
    },

    enablePivot: false,
    enableRowGroup: false,
    enableValue: false,
    filter: false,

    filterParams: {
        buttons: ['reset', 'apply'],
    },

    floatingFilter: false,

    getQuickFilterText: () => {
        return ''
    },

    /**
     * Header menu options if desired are set through menuTabs: []
     * Valid values are:
     * 'filterMenuTab', 'generalMenuTab' and 'columnsMenuTab'
     * Set false to hide icon
     */
    menuTabs: [],
    minWidth: 40,
    hide: true,
    sortable: false,
    resizable: true,
}
